var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "sidemenuFillIcon",
    width: 21,
    height: 22,
    viewBox: "0 0 30.667 40",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-svgrepo-com",
    transform: "translate(-58.733 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(58.733 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M127.667,198.734h18.667a.63.63,0,0,0,.667-.667V187.4a.63.63,0,0,0-.667-.667H127.667a.63.63,0,0,0-.667.667v10.667A.63.63,0,0,0,127.667,198.734Zm.667-10.667h17.333V197.4H128.333Z",
    transform: "translate(-121.667 -172.067)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M204.467,239.267h6.667a.667.667,0,0,0,0-1.333h-6.667a.667.667,0,1,0,0,1.333Z",
    transform: "translate(-192.467 -219.267)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M189.533,272.067H178.867a.667.667,0,0,0,0,1.333h10.667a.667.667,0,0,0,0-1.333Z",
    transform: "translate(-168.867 -250.734)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M88.733-1H62.066a3.3,3.3,0,0,0-3.333,3.333V35.667A3.3,3.3,0,0,0,62.066,39H88.733a.63.63,0,0,0,.667-.667V-.333A.63.63,0,0,0,88.733-1ZM70.066.333V7l-1.6-1.2a.667.667,0,0,0-.8,0L66.066,7V.333Zm-8,0h2.667v8a.641.641,0,0,0,.4.6.613.613,0,0,0,.667-.067L68.066,7.2l2.267,1.667a.948.948,0,0,0,.4.133c.133,0,.2,0,.267-.067a.641.641,0,0,0,.4-.6v-8H88.066v32h-26q-.072,0-.144,0a3.332,3.332,0,0,0-1.856.647V2.333A1.964,1.964,0,0,1,62.066.333Zm26,37.333h-26a2,2,0,1,1,0-4h26Z",
    transform: "translate(-58.733 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M102.067,461.134h22.667a.667.667,0,1,0,0-1.333H102.067a.667.667,0,1,0,0,1.333Z",
    transform: "translate(-98.067 -423.801)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/subject.8e6bf54df9507b5caea06f93e32e69e8.svg";
export { ForwardRef as ReactComponent };